<script setup lang="ts">
	import { cn } from '~/utils/functions'
	export type UiConfigType = {
		wrapper?: string
		container?: string
		loader?: string
	}
	defineProps<{
		defaultClass?: string
		noShadow?: boolean
		loading?: boolean
		loaderHeight?: number
		loaderWidth?: number
		loaderClass?: string
		wrapperClass?: string
		ui?: UiConfigType
	}>()

	const defaultUi = {
		wrapper: 'max-w-[800px] mx-auto',
		container: 'md:bg-white py-6 md:px-10 space-y-9 md:space-y-0 w-full border-gray-200 light-shadow md:rounded-md',
		loader: 'relative w-full !max-w-[800px] !rounded-md mx-auto'
	}

	defineOptions({
		inheritAttrs: false
	})
	const attr = useAttrs()
</script>

<template>
	<div :class="cn({ 'w-full': loading }, defaultUi.wrapper, ui?.wrapper, wrapperClass)">
		<div
			v-show="!loading"
			v-bind="attr"
			:class="cn(defaultUi.container, defaultClass, attr?.class as string, ui?.container)"
		>
			<slot />
		</div>
		<loader-skeleton
			v-if="loading"
			:height="loaderHeight"
			:width="loaderWidth"
			:max-width="false"
			:count="1"
			:class-list="[loaderClass, defaultUi.loader, ui?.loader]"
		/>
	</div>
</template>
